/**
 * Modal para cambiar o borrar el deadline de aprobación.
 */
import React, { useState, useEffect } from 'react';
import { datetimeLocalToIso, toDatetimeLocalValue } from '../../datetimeLocal';
import { studio } from './studioUi';

const DeadlineEditModal = ({ show, onClose, report, onConfirm, onReset, userPermissions, styles }) => {
    const [deadline, setDeadline] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setDeadline(report ? toDatetimeLocalValue(report.approvalDeadline) : '');
    }, [report]);

    const handleConfirmClick = async () => {
        setLoading(true);
        try {
            await onConfirm(report.id, datetimeLocalToIso(deadline));
            onClose();
        } catch (error) {
            // El componente padre (AdminPanel) mostrará la alerta.
        } finally {
            setLoading(false);
        }
    };

    const handleResetClick = async () => {
        setLoading(true);
        try {
            // onReset should return a boolean indicating success
            const success = await onReset(report.id);
            if (success) {
                onClose(); // Close modal only on success
            }
        } catch (error) {
            // AdminPanel will show an alert, so we just log it here.
            console.error("Error al resetear el deadline:", error);
        } finally {
            setLoading(false);
        }
    };

    if (!show || !report) return null;

    return (
        <div style={styles.modalOverlay}>
            <div style={{...styles.modalContent, maxWidth: '500px'}}>
                <h3 style={{ color: '#5E35B1', marginBottom: '20px', marginTop: 0 }}>Editar Deadline</h3>
                <p>Establece una nueva fecha y hora límite para la aprobación del reporte: <strong>{report.reporteNombre}</strong></p>
                
                <div style={{ margin: '20px 0' }}>
                    <span style={studio.fieldLabel}>Nueva fecha límite</span>
                    <input id="deadline-input" type="datetime-local" value={deadline} onChange={(e) => setDeadline(e.target.value)} style={studio.control} />
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', marginTop: '30px' }}>
                    {onReset && userPermissions.maintenance_execute_tasks && (
                        <button onClick={handleResetClick} style={{ ...styles.btnBlue, backgroundColor: '#d93025' }} disabled={loading}>
                            {loading ? 'Procesando...' : 'Resetear aprobación'}
                        </button>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', flex: 1 }}>
                        <button onClick={onClose} style={styles.btnGray} disabled={loading}>Cancelar</button>
                        <button onClick={handleConfirmClick} style={styles.btnBlue} disabled={loading}>
                            {loading ? 'Guardando...' : 'Guardar Deadline'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeadlineEditModal;